import React from 'react';
import {
  StyleSheet, Document, Page, View, Text
} from '@react-pdf/renderer';
import { toBrazilDateTime } from '../../../components/mask';

interface Row {
  Nome: string;
  Email: string;
  Telefone: string;
  CPF: string;
  Categoria: string;
  Status: string;
  Cidade: string;
  'Data Cadastro': string;
  'Data Ativação': string; // ← NOVO CAMPO ADICIONADO
  Habilitado: string;
}

interface OwnProps {
  data: Row[];
  fileName: string;
}

export default function DriversPrint({ data, fileName }: OwnProps) {
  const styles = StyleSheet.create({
    body: {
      padding: 10,
      paddingBottom: 60
    },
    table: {
      width: 'auto',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row'
    },
    // Larguras fixas baseadas no número de colunas
    colHeader: {
      width: '11%', // ← AJUSTADO DE 12% PARA 11% (mais colunas)
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderBottomColor: '#000',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    col: {
      width: '11%', // ← AJUSTADO DE 12% PARA 11% (mais colunas)
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    // Colunas maiores para campos de texto longo
    colLargeHeader: {
      width: '16%', // ← AJUSTADO DE 18% PARA 16% (mais colunas)
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderBottomColor: '#000',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    colLarge: {
      width: '16%', // ← AJUSTADO DE 18% PARA 16% (mais colunas)
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    tableCellHeader: {
      margin: 'auto',
      fontSize: 9, // ← REDUZIDO DE 10 PARA 9 (mais colunas)
      fontWeight: 500,
      textAlign: 'center'
    },
    tableCell: {
      fontSize: 7, // ← REDUZIDO DE 8 PARA 7 (mais colunas)
      padding: 2
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: 'center',
      color: 'grey'
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 10,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey'
    }
  });

  const firstRow = data[0] || {};
  const rowKeys = Object.keys(firstRow);

  // Filtrar as colunas que não devem aparecer (mantendo Data Ativação)
  const filteredRowKeys = rowKeys.filter((key) => key !== 'Categoria' && key !== 'Cidade');

  // Função para determinar a largura da coluna baseada no conteúdo
  const getColumnStyle = (key: string, index: number) => {
    // Campos que precisam de mais espaço
    const largeColumns = ['Nome', 'Email'];
    if (largeColumns.includes(key)) {
      return index === 0 ? styles.colLargeHeader : styles.colLarge;
    }
    return index === 0 ? styles.colHeader : styles.col;
  };

  return (
    <Document>
      <Page size="A4" style={styles.body}>
        <Text style={styles.header} fixed>
          Relatório de Condutores
          {'\n'}
          {fileName}
          {'\n'}
          {toBrazilDateTime(new Date())}
        </Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            {filteredRowKeys.map((key, index) => (
              <View style={getColumnStyle(key, index)} key={key}>
                <Text style={styles.tableCellHeader}>{key}</Text>
              </View>
            ))}
          </View>
          {data.map((row, index) => (
            <View style={styles.tableRow} key={row.CPF || index} wrap>
              {Object.entries(row)
                .filter(([key]) => filteredRowKeys.includes(key))
                .map(([key, value], colIndex) => (
                  <View style={getColumnStyle(key, colIndex)} key={`${row.CPF || index}-${key}`}>
                    <Text style={styles.tableCell}>{String(value)}</Text>
                  </View>
                ))}
            </View>
          ))}
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
          )}
          fixed
        />
      </Page>
    </Document>
  );
}
